<script setup lang="ts">
  import {Model} from "@/app/Model";
  import {FiltriResponsabilita, ResponsabilitaAdmin} from "@/app/data/ResponsabilitaAdmin";

  let model: Model = Model.getReactiveInstance();
  const emit = defineEmits(["recalc"]);

  function handleSubmit(): void {
    //resetto per evitare di portarmi dietro l'offset se sono andato avanti con la paginazione
    model.res_admin.paginazioneResponsabilita_start = 0;

    emit("recalc");
  }
  function resetFiltri(): void {
    model.res_admin.filtriResponsabilita = new FiltriResponsabilita();
    handleSubmit();
  }
</script>

<template>
<div class="admin-filtri mb-2 row">
  <div class="col-4 mb-2">
    <label for="filtri_idDocMaster">ID Doc Master</label>
    <input type="number" class="form-control" id="filtri_idDocMaster" v-model.number="model.res_admin.filtriResponsabilita.id_doc_master">
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_oggettoDiGiudizio">Oggetto del giudizio</label>
    <select class="form-select" id="filtri_oggettoDiGiudizio" v-model="model.res_admin.filtriResponsabilita.tipologia_danno">
      <option value="">Tutti</option>
      <option v-for="item in Model.lista_tipologia_danno" :value="item">{{ item }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_modificaManuale">Modifica Manuale</label>
    <select class="form-select" id="filtri_modificaManuale" v-model="model.res_admin.filtriResponsabilita.modifica_manuale">
      <option value="">Tutti</option>
      <option value="true">Modificati</option>
      <option value="false">Non modificati</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortField">Ordinamento: Campo</label>
    <select class="form-select" id="filtri_sortField" v-model="model.res_admin.filtriResponsabilita.sort_field">
      <option v-for="(item) in ResponsabilitaAdmin.sort_fields" :value="item" :key="'field_'+item">{{ item }}</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <label for="filtri_sortOrder">Ordinamento: Direzione</label>
    <select class="form-select" id="filtri_sortOrder" v-model="model.res_admin.filtriResponsabilita.sort_order">
      <option value="DESC">DESC</option>
      <option value="ASC">ASC</option>
    </select>
  </div>
  <div class="col-4 mb-2">
    <div>&nbsp;</div>
    <button type="button" class="btn btn-primary me-1" @click="handleSubmit()">Filtra</button>
    <button type="button" class="btn btn-sm btn-secondary" @click="resetFiltri()">Reset</button>
  </div>
</div>
</template>